import React from "react";

export function Heading(props){

  return(
    <div className="heading-container mb-5">
      <h1 className="premium-heading">{props.title}</h1>
      <div className="heading-accent"></div>
    </div>
  )  
}